export default function NorthStar({ className = "", glow = true, strokeWidth = 1 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={`${className} ${glow ? "star-glow" : ""}`}
      aria-hidden="true"
    >
      <path
        d="M12 0.5C12.35 6.4 12.9 9.1 15.05 10.4C16.4 11.2 18.4 11.6 23.5 12C18.4 12.4 16.4 12.8 15.05 13.6C12.9 14.9 12.35 17.6 12 23.5C11.65 17.6 11.1 14.9 8.95 13.6C7.6 12.8 5.6 12.4 0.5 12C5.6 11.6 7.6 11.2 8.95 10.4C11.1 9.1 11.65 6.4 12 0.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
